import { Injectable } from '@angular/core';
import { ErrorDialogService } from './error-dialog/error-dialog.service';
import { iValidatedControl } from '../components/ui/controls/iValidatedControl';
import { ServerError } from '../models/errors/serverError';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UIErrorHandler {
  isOpen: boolean = false;

  constructor(
    private errorDialog: ErrorDialogService,
    private router: Router,
  ) {}

  public handleError(message: any) {
    if (!this.isOpen) {
      this.errorDialog
        .open('Error', this.getMessageText(message))
        .subscribe((result) => {
          if (result) {
            this.isOpen = false;

            if (
              message &&
              message.code &&
              message.code == ServerError.ERR_NOT_SIGNED_IN
            ) {
              this.router.navigate(['signin']);
            }
          }
        });
      this.isOpen = true;
    }
  }

  getMessageText(message: any): string {
    if (message.code !== undefined) {
      switch (message.code) {
        case ServerError.ERR_NOT_SIGNED_IN:
          return 'You must be signed in to view the requested page.';
        case ServerError.ERR_AUTHENTICATION:
          return 'You are not allowed to access the requested page or resource.';
        case ServerError.ERR_DATABASE_EMPTY_RECORDSET:
          return 'No results were found.';
        case ServerError.ERR_DATABASE_SYSTEM:
          return 'We encountered a problem retrieving the requested information. Please try again later.';
        case ServerError.ERR_DATABASE_UNEXPECTED_RECORD_COUNT:
          return 'We encountered a problem with the request. Please try again lager.';
        case ServerError.ERR_EMAIL_ADDRESS_UNAVAILABLE:
          return 'The email address is already in use or otherwise not available. Please select a different one.';
        case ServerError.ERR_GATEWAY_APP:
        case ServerError.ERR_GATEWAY_INVALID_REQUEST:
        case ServerError.ERR_GATEWAY_INVALID_RESPONSE:
        case ServerError.ERR_GATEWAY_NO_CONNECTION:
        case ServerError.ERR_GATEWAY_SERVER_ERROR:
        case ServerError.ERR_SERIALIZATION:
        case ServerError.ERR_SYSTEM:
        case ServerError.ERR_GATEWAY_UNHANDLED_REDIRECT:
          return 'Due to an unexpected server issue, your request cannot be completed at this time. Please try again later.';
        case ServerError.ERR_INVALID_INPUT:
          return 'We had trouble processing your request. Please verify that you supplied information for all of the required fields, and that each field is valid.';
        case ServerError.ERR_JWT:
          return 'Something went wrong with your session. If the problem persists, try signing out and then back in again.';
        case ServerError.ERR_RECORD_NOT_CREATED:
          return 'The information could not be saved. Please double check that you supplied all required fields.';
        case ServerError.ERR_RESOURCE_NOT_FOUND:
          return 'We were unable to complete your request. Please try again later.';
        default:
          return message.message;
      }
    } else {
      return message;
    }
  }

  /**
   * Collect all validated controls from the arguments passed in, call validate
   * on each, and return the array of fields that have errors.
   * @param alsoReport report the errors to a popup
   * @param args any number of arrays of controls that implement iValidatedControl
   * @returns collection of FormFieldErrors
   */
  public gatherFormErrors(
    alsoReport: boolean,
    ...args: any[]
  ): FormFieldError[] {
    let allControls: iValidatedControl[] = [];

    for (var i = 0; i < args.length; i++) {
      allControls = allControls.concat(args[i]);
    }

    let errors: FormFieldError[] = [];

    allControls.forEach((component: any) => {
      if (!component.validate()) {
        //sErrors += "<li style=\"cursor:default;\" onclick=\"scrollToTop('" + component.id + "', -80);\")>" + component.labelValue + "</li>";
        //sErrors += "<li>" + component.labelValue + "</li>"
        errors.push(
          new FormFieldError({
            controlId: component.id,
            label: component.labelValue,
            formGroup: component.groupName,
          }),
        );
      }
    });

    if (alsoReport) {
      this.reportFormErrors(errors);
    }

    return errors;
  }

  public reportFormErrors(errors: FormFieldError[]) {
    let sErrors = '';

    errors.forEach((err) => {
      sErrors += '<li>' + err.formGroup + ' - ' + err.label + '</li>';
    });

    if (sErrors != '') {
      let validationMessage =
        'The following fields have errors: <ul>' + sErrors + '</ul>';
      this.handleError(validationMessage);
    }
  }
}

export class FormFieldError {
  text: string | undefined;
  controlId: string | undefined;
  label: string | undefined;
  formGroup: string | undefined;

  constructor(e: Partial<FormFieldError>) {
    this.text = e.text;
    this.controlId = e.controlId;
    this.label = e.label;
    this.formGroup = e.formGroup;
  }
}
